export default __webpack_public_path__ + "static/media/deposit-icon.da9877a3.png";